module.exports = __webpack_public_path__ + "img/Icon_History_Proposal.3d9f0473.svg";